import TrouvilleSeptember2026 from "../../components/before-after/TrouvilleSeptember2026";

const TrouvilleSeptember2026View = () => {

    return (
        <div className="before-after-trouville-september-2026">
            <TrouvilleSeptember2026/>
        </div>
    );
};

export default TrouvilleSeptember2026View;
